import * as React from 'react'
import * as st from './title.module.scss'
import { MakeUrl } from '../../selectors/requestContext'
import { detailPagePath } from '../../utils/url'

export interface ITitleProps {
  title?: string
  asin?: string
  cGti?: string
  showLinkToDP?: boolean
  makeUrl?: MakeUrl
  isRetail?: boolean
  isHover? : boolean
}

export const Title = ({ title, asin, cGti, isRetail, makeUrl, showLinkToDP = false, isHover = false }: ITitleProps) => {
  const decoratedTitle = title && <h1 className={`dv-node-dp-title avu-full-width ${isHover ? st.titleHover: st.title}`}
                                      data-automation-id="title">{title}</h1>
  if (!decoratedTitle) {
    return null
  } else if (showLinkToDP) {
    const titleId = isRetail ? asin || cGti : cGti
    const url = makeUrl && titleId && makeUrl(detailPagePath(titleId), {refTag: 'atv_hover_title'})
    return <a href={url}>{decoratedTitle}</a>
  } else {
    return decoratedTitle
  }
}


